import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  loadUser,
  startLoading,
  stopLoading,
} from "../../../../store/actions/auth";
import { setToast } from "../../../../store/actions/toast";
import {
  axios_createResult,
  axios_getAllOrganizationsOnlyNames,
  axios_getFullOrganizationByName,
  axios_getUserDogs,
} from "../../../../utils/axios-routes";
import "../../../stylesheets/AddResult.css";
import ACCAgility from "../FieldsGroup/ACC_Agility";
import BarnHunt from "../FieldsGroup/BarnHunt";
import CWAGSScent from "../FieldsGroup/C-WAGS_Scent";
import CDSA from "../FieldsGroup/CDSA";
import UKCConformation from "../FieldsGroup/UKC_Conformation";
import UKCNosework from "../FieldsGroup/UKC_Nosework";
import UKCWeight from "../FieldsGroup/UKC_Weight";

const AddResult = (props) => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    dog: "",
    organization: "",
    program: "",
    level: "",
    judge: "",
    date: "",
    section: "",
    faults: "",
    weight: "",
    vehicle: "",
    placement: "",
    class: "",
    category: "Regular",
    time: "",
    variety: "",
    scents: [],
    qualified: false,
    qDowell: "",
    qImproveOn: "",
    elements: [],
  });
  const [dogList, setDogList] = useState([]);
  const [orgList, setorgList] = useState([]);
  const [programList, setprogramList] = useState([]);
  const [levelList, setlevelList] = useState([]); //barn hunt , UKC nosework,
  const [sectionList, setSectionList] = useState([]); // UKC nosework, UCK weight
  const [elementList, setelementList] = useState([]);
  const [placementList, setPlacementList] = useState([]);
  const [eventList, setEventList] = useState([]); // UKC Conformation
  const [varietyList, setVarietyList] = useState([]); // UKC Conformation
  const [classList, setClassList] = useState([]); //  ACC Agility
  const [categoryList, setCategoryList] = useState([]); //  ACC Agility
  const [loadingORG, setLoadingORG] = useState(false); //  ACC Agility

  // ukc weight

  const [vehicleList, setvehicleList] = useState([]);
  const [weightList, setweightList] = useState([]);
  const [requriedJudge, setrequriedJudge] = useState(false);

  const { organization, program } = formData;

  // handling input change
  const handleOnChangeInput = (e) => {
    let data = {};

    // if organization is change load its programs
    if (e.target.name === "organization") {
      props.startLoading();
      setLoadingORG(true);
      axios_getFullOrganizationByName(e.target.value).then((res) => {
        props.stopLoading();
        setLoadingORG(false);
        setprogramList(res.data.organization.sports);
        // setlevelList([]);
        setelementList([]);
        setSectionList([]);
        setPlacementList([]);
        setEventList([]);
        setVarietyList([]);
        // setClassList([]);
        // setCategoryList([]);
      });

      data = {
        program: "",
        level: "",
        section: "A",
        placement: "",
        element: "",
        class: "",
      };
      // if program is change load its levels
    } else if (e.target.name === "program") {
      const program = programList?.filter((sport) => {
        if (sport.name === e.target.value) return sport;
      })[0];

      setlevelList(program?.levels);
      setelementList(program?.elements);
      setSectionList(program?.sections);
      setPlacementList(program?.placements);

      // ukc weight
      setweightList(program?.weights);
      setvehicleList(program?.vehicles);

      //UKC conformation
      setEventList(program?.events || []);
      setVarietyList(program?.variety || []);
      setClassList(program?.classes || []);
      setCategoryList(program?.categories || []);
    }

    if (e.target.name === "elementsPassed") {
      setFormData((d) => {
        if (d.elements.includes(e.target.value)) {
          return {
            ...d,
            elements: d.elements.filter((de) => de !== e.target.value),
          };
        } else {
          return {
            ...d,
            elements: [...d.elements, e.target.value],
          };
        }
      });
    } else {
      if (
        e.target.name === "level" &&
        (e.target.value === "Master A" || e.target.value === "Championship")
      ) {
        setrequriedJudge(true);
      } else if (e.target.name === "level") {
        setrequriedJudge(false);
      }

      const temp = {
        [e.target.name]: e.target.value,
        ...data,
      };

      if (
        e.target.name === "class" &&
        (e.target.value === "Challenge" ||
          e.target.value === "Team relay" ||
          e.target.value === "Steeplechase")
      ) {
        temp.level = "N/A";
      }

      setFormData((data) => ({ ...data, ...temp }));
    }
  };

  const getUserDog = () => {
    props.startLoading();
    axios_getUserDogs().then((res) => {
      if (res.data.dogs) {
        setDogList(res.data.dogs);
      }
      axios_getAllOrganizationsOnlyNames().then((res) => {
        setorgList(res.data.organizations);
        props.stopLoading();
      });
    });
  };
  useEffect(() => {
    getUserDog();
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    props.startLoading();
    axios_createResult(formData)
      .then((res) => {
        props.stopLoading();
        if (res.data.success) {
          props.loadUser();
          props.setToast([{ type: "success", msg: "Result added" }]);
          history.push("/profile/results");
          props.setaddingResult(false);
        } else {
          props.setToast([
            { type: "warning", msg: "Server error! please try again" },
          ]);
          history.push("/profile/results");
        }
      })
      .catch((error) => {
        props.stopLoading();
        props.setToast([{ type: "error", msg: "Internal Server Error" }]);
      });
  };

  let FieldGroup = BarnHunt;

  if (organization === "Barn Hunt Association") {
    FieldGroup = BarnHunt;
  } else if (organization === "UKC") {
    if (program === "Nosework") {
      FieldGroup = UKCNosework;
    } else if (program === "Weight Pull") {
      FieldGroup = UKCWeight;
    } else if (program === "Conformation") {
      FieldGroup = UKCConformation;
    }
  } else if (organization === "C-WAGS") {
    if (program === "Scent") {
      FieldGroup = CWAGSScent;
    }
  } else if (organization === "Agility Association of Canada (AAC)") {
    // if (program === "Agility") {
    FieldGroup = ACCAgility;
    // }
  } else if (organization === "CDSA") {
    FieldGroup = CDSA;
  }

  useEffect(() => {
    if (organization === "CDSA" && !loadingORG && programList.length) {
      handleOnChangeInput({ target: { name: "program", value: "Scent" } });
    }
  }, [organization, loadingORG, programList]);

  useEffect(() => {
    if (
      organization === "Agility Association of Canada (AAC)" &&
      loadingORG === false &&
      programList.length
    ) {
      handleOnChangeInput({ target: { name: "program", value: "Agility" } });
    }
  }, [organization, loadingORG, programList]);

  return (
    <div className="add-result">
      <div className="add-result-data">
        <form className="add-result-form" onSubmit={handleFormSubmit}>
          <div className="row">
            <div className="col-md-12">
              <h5 className="heading text-center">Add Results</h5>
            </div>

            <div className="col-md-12">
              <FieldGroup
                fields={formData}
                handleOnChangeInput={handleOnChangeInput}
                orgList={orgList}
                dogList={dogList}
                levelList={levelList}
                programList={programList}
                placementList={placementList}
                elementList={elementList}
                sectionList={sectionList}
                setaddingResult={props?.setaddingResult}
                weightList={weightList}
                vehicleList={vehicleList}
                eventList={eventList}
                varietyList={varietyList}
                classList={classList}
                categoryList={categoryList}
                requriedJudge={requriedJudge}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
});
export default connect(mapStatetoProps, {
  setToast,
  startLoading,
  stopLoading,
  loadUser,
})(AddResult);
